<template>
  <ComponentLayout id="new-tender-terms-step">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :check-exit="checkChages"
        :dialog.sync="is_dialog"/>
    </template>
    <template #main_content>
      <StepsInfo/>
      <div class="width-100 mt-2 mb-8 h1-headline text-left">
        {{ $t('Tenders.SpecifyDatesForHolding') }}
      </div>
      <v-card
        class="width-100 main__light_green px-6 radius-8 text-start pb-8"
        elevation="0">
        <TermsCard
          ref="dates"
          :date-from.sync="tender.deliveryPeriodFrom"
          :date-to.sync="tender.deliveryPeriodTo"
          :end-date.sync="proposals_date"
          :end_date_title="!auction || $t('Tenders.AuctionClosing')"
          :fixed_value="from_plan"
          :minimal-date="tender.isUrgent ? new Date() : null"
          :planned-date.sync="tender.scheduledStart"
          :publish_btn="!auction && !has_required_agreement"
          :use-date-range="!bidding_type.isFrameFirstStage"/>
        <div
          v-if="show_prolongationRule"
          class="align-start black--text h6-text flex flex-between">
          <div
            class="width-65 pt-8 main__light_green">
            <div class="h4-headline black--text pb-3 px-0">
              {{ $t('Tenders.AutoContinuationStatus',
                    {status: auction ? $t('Tenders.OfAuction') : $t('Tenders.OfAcceptanceOfOffers') }) }}
            </div>
            <div class="secondary__green_not_active--text">
              {{ $t('Tenders.AutomaticallyContinueToReceiveOffers',
                    {status: smallFirstLetter(auction ? $t('Tenders.Auction') : $t('Tenders.AcceptingOffers')) }) }}
            </div>
            <RadioGroup
              class-name="mt-0 py-0"
              data-qa="prolog"
              :model.sync="continue_recive_offers"
              @change="chooseProlog"/>
            <ProlongRulesRadio
              v-if="continue_recive_offers"
              data-qa="continue-recive-offers"
              :prolongation_rules="prolongation_rules"
              :value.sync="tender.prolongRuleCode"/>
          </div>
          <sAlert
            width="230px">
            {{ $t('Tenders.ConditionsOfTenderExtension') }}
            <template slot="desc">
              {{ $t('Tenders.ConditionsOfTenderExtensionText') }}
            </template>
          </sAlert>
        </div>
      </v-card>
    </template>
    <template #footer>
      <CreateTenderFooter
        key="footer"
        :back="cancel"
        back_btn
        :check-chages="checkChages"
        :check_disable="$_minTenderPeriodDate"
        :next="beforeNext"
        :next_btn="!auction "
        :next_disable="!!checkPeriod"
        :publish.sync="is_dialog"/>
    </template>
  </ComponentLayout>
</template>
<script>
import StepsInfo from 'components/tenders/StepsInfo.vue'
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import TermsCard from 'components/tenders/tender creation/TermsCard.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import CreateTenderFooter from 'components/tenders/CreateTenderFooter.vue'
import ProlongRulesRadio from 'components/tenders/tender creation/ProlongRulesRadio.vue'

import { beforeunloadMixin, datePickerMixin, filterSortMixin, modalMixin, tenderMixin } from 'mixins'
import moment from 'moment'
import { mapGetters } from 'vuex'

/**
 * Страница создания тендера. Шаг 4 Термины проведения
 */
export default {
  name: 'tenderTermsPage',
  mixins: [ modalMixin ,filterSortMixin, tenderMixin, beforeunloadMixin, datePickerMixin, ],
  data () {
    return {
      continue_recive_offers: false,
      prolongation_rules: [],
      bidding_type: {},
      old: {},
      from_plan: null,
    }
  },
  props: {
    auction: Boolean
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
      NewTenderInfo: 'getNewTenderInfo',
      info: 'getNewTenderInfo'
    }),
    is_dialog: {
      get() {
        return this.auction
      },
      set( newValue ) {
        if ( !newValue ) {
          this.cancel()
        }

        this.$emit('update:auction', newValue)
      }
    },
    tender: {
      get() {
        return this.$store.getters.getNewTender
      },
      set(newValue) {
        this.$store.commit('setNewTender', newValue)
      }
    },
    proposals_date: {
      get() {
        return this.tender.tenderPeriodTo
      },
      set( newValue ) {
        if ( newValue ) {
          this.tender.tenderPeriodTo = newValue
        }

      }
    },
    show_prolongationRule() {
      return this.bidding_type?.prolongationRuleAvailable && (!this.bidding_type?.isMultistage || this.auction)
    },
    checkPeriod() {
      if ( !this.tender?.tenderPeriodTo || !parseFloat(this.tender?.tenderPeriodTo )) {
        return true
      }
      this.$refs.dates?.setMinPlanned()
      let from =  this.tender.deliveryPeriodFrom,
        to =  this.tender.deliveryPeriodTo ,
        tender_to = this.tender?.tenderPeriodTo,
        result = !!this.proposals_min || ( ( to  && moment(tender_to).format('YYYY-MM-DD') > moment(to).format('YYYY-MM-DD') )
        || (from && moment(tender_to).format('YYYY-MM-DD') > moment(from).format('YYYY-MM-DD') )
        || (to && from &&  moment(to).format('YYYY-MM-DD') < moment(from).format('YYYY-MM-DD') ))
        || !!this.$refs.dates?.min_plnned

      return result
    },
  },
  async created() {
    this.old = this.$_.cloneDeep( this.tender )

    if ( (this.auction || !this.tender.tenderPeriodTo || !moment(this.tender.tenderPeriodTo).isValid()) && this.min_date) {
      this.tender.tenderPeriodTo = this.getMinDate()  //вот єто нужно перенести
    }

    let scheduledDate = this.tender?.tenderPublishedSchedule?.scheduledDate
    if ( scheduledDate && !this.auction ) {
      this.tender.scheduledStart = scheduledDate
    }
    if (this.tender.prolongRuleCode  && !this.bidding_type?.prolongationRuleAvailable ) {
      this.continue_recive_offers = true
    }

    this.bidding_type = this.tender.biddingType

    if (this.show_prolongationRule) {
      this.$store.dispatch('setProlongationRule')
        .then(res => this.prolongation_rules = res)
        .catch(res => this.$log_error('prolongationRule',res))
    }
    this.tender.tenderProlongationRules = []
    if ( this.NewTenderInfo.mode == 'plan' ) {
      this.from_plan = this.tender.deliveryPeriodTo
    }

  },
  mounted() {
    if ( this.tender.scheduledStart ) {
      this.$refs.dates.scheduleStart()
    }
  },
  methods: {
    beforeNext() {
      if ( !this.$refs.dates.planned_publishing ) {
        this.tender.scheduledStart = null
        this.tender.tenderPublishedSchedule = null
      } else {
        this.tender.tenderPublishedSchedule = this.tender.tenderPublishedSchedule || { }
        this.tender.tenderPublishedSchedule.scheduledDate = this.tender.scheduledStart
      }
      if (!this.continue_recive_offers) {
        this.tender.prolongRuleCode = null
      }
      this.tender.tenderProlongationRules = []
    },
    cancel() {
      this.tender = this.$_.cloneDeep( this.tender )
    },
    checkChages() {
      return this.tender.tenderId && (
        moment(this.old.tenderPublishedSchedule?.scheduledDate ).format() != moment(this.tender.scheduledStart  || undefined).format()
        || moment(this.old.tenderPeriodTo).format() != moment(this.tender.tenderPeriodTo).format()
        || moment(this.old.deliveryPeriodTo).format() != moment(this.tender.deliveryPeriodTo).format()
        || moment(this.old.deliveryPeriodFrom).format() != moment(this.tender.deliveryPeriodFrom).format()
        || this.old.prolongRuleCode != this.tender.prolongRuleCode )
    },
    chooseProlog() {
      this.tender.prolongRuleCode = this.tender.prolongRuleCode || this.prolongation_rules[0].code
    },
    getMinDate() {
      let date = moment( this.min_date ).add(3, 'd')
      while ( !this.$_allowedDates( date.format() ) ) {
        date.add(1, 'd')
      }

      return date.format('YYYY-MM-DDTHH:mm:ss')
    }
  },
  components: {
    StepsInfo,
    TermsCard,
    RadioGroup,
    ComponentLayout,
    TenderBreadcrumbs,
    ProlongRulesRadio,
    CreateTenderFooter
  }
}
</script>
<style lang="scss">
.tender-terms.time-menu {
  .v-time-picker-clock {
    background: none !important;
    background: var(--v-secondary__green_chosen-base);
  }
}
</style>
